import PayoutsTable from './PayoutsTable';

export default PayoutsTable;
